var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({fontSize:_vm.fontSize,color:'#fff'})},[_c('h2',[_vm._v("自定义组件")]),_c('br'),_c('h3',[_vm._v("我是参数:"+_vm._s(_vm.option))]),_c('br'),_c('h3',[_vm._v("data:"+_vm._s(_vm.dataChart))]),_c('br'),_c('h3',[_vm._v("params:"+_vm._s((_vm.dataAxios.config || {}).params))]),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }